import {CURRENT_SESSION} from "../constants/sessionActionTypes";

const setPreferredHost = (preferredHost) => ({ type: CURRENT_SESSION.SET_PREFERRED_HOST, preferredHost })
const setGlobalConfig = (globalConfig) => ({ type: CURRENT_SESSION.SET_GLOBAL_CONFIG, globalConfig })

export {
  setPreferredHost,
  setGlobalConfig,
}
